<template>
  <div class="home"
       :style="{backgroundImage: shopInfo && shopInfo.background_img ? `url(${shopInfo.background_img})` : `url('../../static/image/logo.png')`}">
    <!--    <div class="home-content-bg" @click="drawerFun()" v-if="openid === ''"></div>-->
    <!--    <div class="home-content-bg"></div>-->
    <div class="home-content">
      <com-header @loginCall="loginCall"/>
      <div class="home-list-box">
        <div class="home-list-right" @click="navIconFun('left')" v-if="navHomeList.length > 6">
          <img src="../../static/image/home-left.png" alt="">
        </div>
        <div class="home-list-scroll">
          <div class="home-list" :style="{left: `-${(navPage- 1) * 13.9}vw`}">
            <div class="home-list-item" v-for="item in navHomeList">
              <div class="home-card">
                <img :src="item.cover_image" alt="" @click="pageJump(item)">
              </div>
              <div class="home-item-name">{{ item.name_en }}</div>
            </div>

          </div>
        </div>

        <div class="home-list-right" @click="navIconFun('right')" v-if="navHomeList.length > 6">
          <img src="../../static/image/home-right.png" alt="">
        </div>
      </div>

      <div class="home-footer">
        <div class="home-footer-right" v-if="openid !== ''">
          <img src="../../static/image/start.png" alt="" @click="clientExit()">
          <!--          <p v-if="openid == ''">开始</p>-->
          <p>退出</p>
        </div>
      </div>
    </div>

    <!--    <el-dialog-->
    <!--      :visible.sync="dialogVisible"-->
    <!--      :before-close="drawerFun">-->
    <!--      <div class="login-title">-->
    <!--        <h4>微信扫码登录</h4>-->
    <!--        <span>{{ `请在（${loginTime}）秒内扫码登录` }}</span>-->
    <!--      </div>-->
    <!--      <div class="login_container">-->
    <!--        <img :src="wxUrl" alt="">-->
    <!--      </div>-->
    <!--      <div class="login-tip">-->
    <!--        扫码登录后，收藏客户喜欢的照片，可以实时同步小程序-->
    <!--      </div>-->
    <!--    </el-dialog>-->

    <div class="progress-box" v-if="downFlag" @click="downLoadClick">
      <div class="progress-content">
        <el-progress :text-inside="true" :stroke-width="15" :percentage="total > 0 ? parseInt((current/total)*100) :0"
                     status="warning"></el-progress>
        <div class="progress-tips">
          {{ current }}/{{ total }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
let timer = null
export default {
  name: 'home',
  data () {
    return {
      dialogVisible: false,
      navDrawer: false,
      navList: [],
      openid: '',
      shopInfo: {},
      screenFlag: false,
      downFlag: false,
      current: 0,
      total: 0,
      codeData: {},
      loginTime: 0,
      collectNum: -1,
      navPage: 1,
      navHomeList: []
    }
  },
  computed: {
    wxUrl () {
      return `data:image/jpeg;base64,${this.codeData.base64_image_content}`
    }
  },
  beforeRouteLeave (to, form, next) {
    this.getClearTime()
    next()
  },
  created () {
    this.getHomeNavList()
  },
  mounted () {
    this.shopInfo = JSON.parse(window.localStorage.getItem('shopInfo'))
    if (window.localStorage.getItem('openid')) {
      this.openid = window.localStorage.getItem('openid')
      this.getCollect()
    }
    this.getNavList()
  },
  methods: {
    loginCall () {
      this.openid = window.localStorage.getItem('openid')
    },
    navIconFun (type) {
      if (this.navList.length > 6) {
        if (type === 'right') {
          this.navPage++
        }
      }
      if (type === 'left' && this.navPage > 1) {
        this.navPage--
      }
    },
    getWxLogin () {
      this.$get('/pc/shop/memberInfo', {scene: this.codeData.scene}).then((res) => {
        if (res.data.is_scan_login === 1) {
          window.localStorage.setItem('openid', res.data.openid)
          this.openid = res.data.openid
          this.getClearTime()
          this.getCollect()
        }
      }).catch((error) => {

      })
    },
    getCollect () {
      this.$get('/pc/shop/myCollect', {
        size: 9,
        page: 1,
      }, this.$message).then((res) => {

        this.collectNum = res.meta.total
      }).catch((error) => {

      })
    },
    downLoadClick () {
      this.$message.error('资源正在加载中，请稍后！')
    },
    clientExit () {
      this.openid = ''
      window.localStorage.removeItem('openid')
    },
    pageJump (item) {
      const {id, iSkipChildList} = item
      let router = ''
      if (id === 'newprod') {
        router = 'newProduct'
      } else if (id === 'photostyle') {
        router = 'classification'
      } else if (id === 'combo') {
        router = 'setMenu'
      } else {
        if (iSkipChildList === 0) {
          router = `brand?id=${item.id}`
        } else {
          router = `brandDetails?id=${item.id}&sourceType=home`
        }
      }
      this.$router.push(router)
    },
    drawerFun () {
      if (!this.dialogVisible) {
        this.loginTime = 90
        this.$get('/pc/shop/getUnlimit', {}).then((res) => {
          clearInterval(timer)
          timer = null
          this.codeData = res.data
          this.dialogVisible = true
          timer = setInterval(() => {
            this.loginTime--
            if (this.loginTime <= 0) {
              this.getClearTime()
            }
            this.getWxLogin()
          }, 1000)
        }).catch((error) => {

        })

      } else {
        this.getClearTime()
      }

    },

    getClearTime () {
      this.dialogVisible = !this.dialogVisible
      clearInterval(timer)
      timer = null
    },
    navDrawerFun () {
      this.navDrawer = !this.navDrawer
    },
    getNavList () {
      // this.$get('/pc/shop/secondClassify', {}).then((res) => {
      //   this.navList = res.data
      //   window.localStorage.setItem('navList', JSON.stringify(res.data))
      // }).catch((error) => {
      // })
    },
    getHomeNavList () {
      this.$get('/pc/shop/home', {}).then((res) => {
        this.navHomeList = res.data
      }).catch((error) => {
      })
    },
    downImg () {
      this.$get('/pc/shop/download', {}).then((res) => {
        this.downFlag = true
        var loader = new resLoader({
          resources: res.data,
          onStart: function (total) {
          },
          onProgress: (current, total) => {
            this.current = current
            this.total = total
            if (current === total) {
              this.downFlag = false
              this.$message.error('资源加载完成，请开始使用！')
            }
          },
          onComplete: function (total) {

          }
        })
        loader.start()
      }).catch((error) => {
      })
    },
    searchPage () {
      this.$router.push({name: 'search'})
    }
  }
}
</script>

<style scoped lang="less">
.home {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  overflow: hidden;
}

.home-content {
  position: relative;
  width: 100vw;
  margin-top: 80px;
  box-sizing: border-box;
}


.home-content-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  buttom: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
}

.home-list-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8.3vw;
}

.home-list-right, home-list-left {
  width: 25px;
  height: 47px;

  img {
    width: 100%;
    height: 100%;
  }
}

.home-list-scroll {
  width: 83.4vw;
  height: 34vw;
  margin: 0 55px;
  overflow: hidden;
  position: relative;
}

.home-list {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 20px;

  .home-list-item {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    //padding-left: 15px;
    width: 13.9vw;

    .home-card {
      width: 13.23vw;
      height: 23.54vw;
      background: #FFF2DE;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .home-item-name {
      margin-top: 20px;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #E8B45E;
    }
  }

  .home-list-item:hover {
    transform: scale(1.05);
    transition: all 0.3s;
  }
}

.home-footer {
  position: fixed;
  right: 80px;
  bottom: 80px;
}

.home-footer-left {
  display: flex;
  align-items: center;
  height: 82px;
  line-height: 82px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 4px;
}

.home-footer-item {
  margin: 0 30px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}

.el-drawer__header {
  display: none !important;
  padding: 0;
}

.el-icon-close {
  display: none;
}

.el-dialog {
  width: 35vw;
}

.el-dialog {
  padding: 20px;
  background: #FFFFFF;
  border-radius: 8px;
  width: 35vw;
}

.el-dialog__header {
  display: none !important;
}

#login_container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-download {
  visibility: hidden
}

.home-footer-right img {
  width: 42px;
  height: 42px;
}

.home-footer-right p {
  margin-top: 5px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #E8B45E;
}

.el-dialog {
  width: 32.76vw !important;
  box-sizing: border-box;
  padding: 40px 0;
  border-radius: 4px;
}

.login-button {
  width: 24.48vw;
  height: 57px;
  line-height: 57px;
  background: #333333 !important;
  border-radius: 4px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  text-align: center;
}

.progress-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
}

.progress-content {
  position: absolute;
  top: 190px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 46.87vw;
  height: 10px;
}

.progress-tips {
  width: 100%;
  line-height: 50px;
  height: 50px;
  font-size: 24px;
  color: #000;
  text-align: center;
}

.login-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-title h4 {
  line-height: 40px;
  font-size: 30px;
  font-weight: 600;
  color: #222222;
}

.login-title span {
  margin: 20px 0;
  font-size: 20px;
  font-weight: 400;
  color: #353535;
}

.login_container {
  width: 20.83vw;
  height: 20.83vw;
  margin: 30px auto;
}

.login_container img {
  width: 20.83vw;
  height: 20.83vw;
}

.login-tip {
  margin-top: 50px;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #353535;
}

</style>



// WEBPACK FOOTER //
// src/views/home.vue